module.exports = __webpack_public_path__ + "static/img/bg.7854f4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = dZ/S
// module chunks = 1